import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { NativeSelect } from '@/components/ui/native-select'
import { EFEITO_LABELS, NATUREZA_LABELS, ufChoice } from '@/lib/deadlines'
import type { Efeito, Natureza, SuspensionInput } from '@/services/deadline-service'

const EMPTY = { uf: '', dataInicio: '', dataFim: '', natureza: 'SUSPENSAO' as Natureza, efeito: 'PRAZOS_SUSPENSOS' as Efeito, motivo: '', fonteUrl: '' }

/** Cadastro de suspensão de prazos ou feriado do tribunal/UF (sócio). Feriado municipal não entra no cálculo. */
export function SuspensionForm({ tribunal, onSubmit }: { tribunal: string; onSubmit: (input: SuspensionInput) => Promise<boolean> }) {
  const [form, setForm] = useState(EMPTY)
  const [busy, setBusy] = useState(false)
  const ufs = ufChoice(tribunal)?.options ?? []
  const set = (key: keyof typeof EMPTY) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => setForm((f) => ({ ...f, [key]: e.target.value }))

  const submit = async (event: React.FormEvent) => {
    event.preventDefault()
    setBusy(true)
    const ok = await onSubmit({
      tribunal,
      uf: form.uf || null,
      dataInicio: form.dataInicio,
      dataFim: form.dataFim || form.dataInicio,
      natureza: form.natureza,
      efeito: form.efeito,
      motivo: form.motivo.trim(),
      fonteUrl: form.fonteUrl.trim() || null,
    })
    setBusy(false)
    if (ok) setForm(EMPTY)
  }

  return (
    <form onSubmit={submit} aria-label="Nova suspensão" className="grid gap-3 sm:grid-cols-3">
      <div><Label htmlFor="s-inicio">Início</Label><Input id="s-inicio" type="date" value={form.dataInicio} onChange={set('dataInicio')} required /></div>
      <div><Label htmlFor="s-fim">Fim</Label><Input id="s-fim" type="date" value={form.dataFim} onChange={set('dataFim')} /></div>
      <div>
        <Label htmlFor="s-uf">UF (opcional)</Label>
        <NativeSelect id="s-uf" value={form.uf} onChange={set('uf')}>
          <option value="">Todas do {tribunal}</option>
          {ufs.map((u) => <option key={u} value={u}>{u}</option>)}
        </NativeSelect>
      </div>
      <div>
        <Label htmlFor="s-natureza">Natureza</Label>
        <NativeSelect id="s-natureza" value={form.natureza} onChange={set('natureza')}>
          {Object.entries(NATUREZA_LABELS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </NativeSelect>
      </div>
      <div>
        <Label htmlFor="s-efeito">Efeito no prazo</Label>
        <NativeSelect id="s-efeito" value={form.efeito} onChange={set('efeito')}>
          {Object.entries(EFEITO_LABELS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </NativeSelect>
      </div>
      <div className="sm:col-span-3"><Label htmlFor="s-motivo">Motivo / ato</Label><Input id="s-motivo" value={form.motivo} onChange={set('motivo')} required minLength={3} placeholder="Ex.: Decreto Judiciário nº … — indisponibilidade do PJe" /></div>
      <div><Label htmlFor="s-fonte">Link da fonte</Label><Input id="s-fonte" type="url" value={form.fonteUrl} onChange={set('fonteUrl')} placeholder="https://" /></div>
      <div className="sm:col-span-3"><Button type="submit" loading={busy}>Cadastrar</Button></div>
    </form>
  )
}
